import React from "react";
import { useFormik } from "formik";
import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useHistory, useParams } from "react-router-dom";
import axios from "../../../helper/axios";
import { Table, Button, Modal, Form } from "react-bootstrap";
import { patientregistration } from "../../../helper/schemas";
import { ToastContainer, toast } from 'react-toastify';
import * as Yup from "yup";  // Import Yup for validation
import { useUser } from "../../../Provider";

// Define Yup validation schemas
const ValidationSchema = Yup.object().shape({
  floorname: Yup.string().required('Floor name is required'),
  hospitalcode: Yup.string().required("Please select the hospitalcode"),
  description: Yup.string().required("Please enter the description"),
});

const ValidationSchema1 = Yup.object().shape({
  floorname: Yup.string().required('Floor name is required'),
  description: Yup.string().required("Please enter the description"),
});

// Define initial form values
const initialValues = {
  floorname: "",
  description: "",
  hospitalcode: "",
};

// EditFloor component
const EditFloor = () => {
  // Extract user details and functions from the context
  const { user, userHospitalcode, userrole1, isAuthRole, isAuthorized, gettokenId, token } = useUser();

  // Initialize React Router's history hook
  const history = useHistory();

  // State variables for handling success, error, and current date
  const [message, setMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  // Extract floorid from URL params
  const { floorid } = useParams();

  // Function to dynamically select the validation schema based on userHospitalcode
  const getValidationSchema = () => {
    return userHospitalcode === 1 ? ValidationSchema : ValidationSchema1;
  };

  // Formik hooks for form handling
  const {
    values,
    errors,
    touched,
    setValues,
    handleChange,
    handleBlur,
    resetForm,
    handleSubmit,
  } = useFormik({
    initialValues,
    validationSchema: getValidationSchema(), // Apply validation schema
    onSubmit: async (values, { resetForm }) => {
      try {
        if (userHospitalcode !== undefined) {
          const data = new FormData();

          // Append all form fields to the FormData object
          data.append('document', JSON.stringify(values));
          data.append('bedtypeid', floorid); // Assuming bedtypeid is now a number
          data.append('userHospitalcode', JSON.stringify(userHospitalcode));
          data.append('currentDateTime', JSON.stringify(getCurrentDateTime()));
          data.append('gettokenId', JSON.stringify(gettokenId));
          data.append('currentDate', JSON.stringify(currentDate));

          console.log(JSON.stringify(values));

          const response = await axios.post(`/FloorUpdate/'${floorid}'`, data, {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
            params: {
              hospitalcode: userHospitalcode,
              userrole: userrole1,
            },
          });

          if (response.status === 200) {
            return history.push("/listviewfloor");
          } else {
            console.error('Error in admitting patient');
            setSuccess(false);
            setError(true);
          }
        }
      } catch (error) {
        console.error('Error:', error.message);
        setSuccess(false);
        setError(true);
        toast.error('Something Went Wrong');
      }
    },
  });

  // Function to get the current date and time
  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const currentDateTimeString = `${year}-${month}-${day}T${hours}:${minutes}`;
    return currentDateTimeString;
  };

 
  let Showdate = new Date();
    let ShowTodaydate =
        Showdate.getFullYear() +
        "-" +
        (Showdate.getMonth() + 1) +
        "-" +
        Showdate.getDate();
    const [currentDate, setCurrentDate] = useState(ShowTodaydate);

  // State variable to store hospital code data
  const [data, setData] = useState([]);

  // useEffect to load user details, hospital code, and floor details on component mount or when dependencies change
  useEffect(() => {
    const loadData = async () => {
      await loadHospitalcode();
      await loadFloor();
    };
    loadData();
  }, [userHospitalcode, userrole1, isAuthorized]);

  // Function to fetch hospital codes
  const loadHospitalcode = async () => {
    if (userHospitalcode !== undefined && userrole1 !== undefined) {
      const res = await axios.get("/gethospitalcode", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          hospitalcode: userHospitalcode,
          userrole: userrole1,
        },
      });
      setData(res.data);
      console.log(res.data);
    };
  }

  // Function to fetch floor details
  const loadFloor = async () => {
    try {
      if (userHospitalcode !== undefined && userrole1 !== undefined) {
        const response = await axios.get(`/getfloorbyfloorid/${floorid}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            hospitalcode: userHospitalcode,
            userrole: userrole1,
          },
        });

        const floorData = response.data;
        console.log("Floor Data:", floorData)
        setValues(floorData);
      }
    } catch (error) {
      console.error('Error loading floor details:', error.message);
      alert('Something Went Wrong');
    }
  };

  // JSX structure for the form
  return (
    <div className="p-3 pt-0 appointment">
      <Helmet>
        <title>Update Floor Details | {window.location.hostname} | Hospital Management Software | Smart Solutions for Hospital Efficiency</title>
      </Helmet>
      <form onSubmit={handleSubmit}>
        <div className="fill header">
          <h3 className="float-left"> Floor Edit</h3>
        </div>
        <div className="patient-new primary-info">
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                  <div className="col-md-12 mt-3">
                    <div className="row">
                      <div className="col-md-4">
                        <label htmlFor="floorname" className="col-form-label leftone">
                          Floor Name
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          autoComplete="off"
                          name="floorname"
                          id="floorname"
                          placeholder="Floor Name"
                          value={values.floorname}
                          onChange={handleChange}
                          className="form-control ember-text-field text-left ember-view"
                        />
                        {errors.floorname && touched.floorname ? (
                          <p className="form-erroremployee">{errors.floorname}</p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  {isAuthorized ? (<div className="col-md-12 mt-3">
                    <div className="row">

                      <div className="col-md-4">
                        <label
                          htmlFor="hospitalcode"
                          className="col-form-label leftone"
                        >
                          Hospital Code
                        </label>
                      </div>
                      <div className="col-md-8">
                        {/* Conditionally render the dropdown and input field */}
                        {isAuthorized ? (
                          <input
                            type="text"
                            autoComplete="off"
                            name="hospitalcode"
                            id="hospitalcode"
                            placeholder="Hospital Code"
                            value={values.hospitalcode}
                            // onChange={handleChange}
                            // onBlur={handleBlur}
                            disabled={true} // Set the input as disabled
                            // style={{ width: '73%', height: '32px', border: '1px solid #ced4da', color: '#495057' }}
                            className="form-control "
                          >
                           
                          </input>
                        ) : (
                          <input
                            type="text"
                            name="hospitalcode"
                            id="hospitalcode"
                            value={userHospitalcode}
                            disabled={true} // Set the input as disabled
                            className="form-control "
                          />
                        )}
                        {isAuthorized && errors.hospitalcode && touched.hospitalcode ? (
                          <p className="form-erroremployee">{errors.hospitalcode}</p>
                        ) : null}
                      </div></div></div>) : null}



                </div>

                <div className="col-md-6">
                  <div className="col-md-12 mt-3">
                    <div className="row">
                      <div className="col-md-4">
                        <label htmlFor="description" className="col-form-label leftone">
                          Description
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          autoComplete="off"
                          name="description"
                          id="description"
                          placeholder="Description"
                          value={values.description}
                          onChange={handleChange}
                          className="form-control ember-text-field text-left ember-view"
                        />
                        {errors.description && touched.description ? (
                          <p className="form-erroremployee">{errors.description}</p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-buttons">
          <Button type="submit" variant="success" className="mx-3">
            Update
          </Button>
        </div>
      </form>
    </div>
  );
};

export default EditFloor;